import { CMSINFO_REDIRECT_QUERY } from 'src/constants/cmsInfoRedirectQuery';
import { EVENT_LIST_PAGE_SEARCH_PARAMS } from 'src/pages/eventsList/types';
import { BET_LIST_PAGE_SEARCH_PARAMS } from '../pages/bets/types/betListTypes';

export const clearRouteQuery = (): void => {
  const url = new URL(window.location.href);
  history.replaceState(null, '', url.origin + url.pathname);
};

export const isInIframe = window.location.search?.includes('token');

export const navigateToSpecificPage = (info: string, fr: string, token: string): void => {
  const parsedInfo = info.split(':');
  const tokenAndFR = `fr=${fr}&token=${token}`;
  if (parsedInfo[0] === CMSINFO_REDIRECT_QUERY.PLAYER_CARD) {
    window.location.replace(`/playerCard/${parsedInfo[1]}/${parsedInfo[2]}?${tokenAndFR}`);
  } else if (parsedInfo[0] === CMSINFO_REDIRECT_QUERY.BETS_BY_EVENT) {
    window.location.replace(
      `/bets?${BET_LIST_PAGE_SEARCH_PARAMS.EVENT_ID}=${parsedInfo[1]}&${BET_LIST_PAGE_SEARCH_PARAMS.SET_NO_DATE}=true&${tokenAndFR}&${BET_LIST_PAGE_SEARCH_PARAMS.IS_REDIRECT}=true`,
    );
  } else if (parsedInfo[0] === CMSINFO_REDIRECT_QUERY.BETS_BY_PLAYER) {
    window.location.replace(
      `/bets?${BET_LIST_PAGE_SEARCH_PARAMS.PLAYER_ID}=${parsedInfo[1]}&${BET_LIST_PAGE_SEARCH_PARAMS.SET_NO_DATE}=true&${tokenAndFR}&${BET_LIST_PAGE_SEARCH_PARAMS.IS_REDIRECT}=true`,
    );
  } else if (parsedInfo[0] === CMSINFO_REDIRECT_QUERY.BETS_OVERVIEW) {
    window.location.replace(`/bets?${BET_LIST_PAGE_SEARCH_PARAMS.SET_NO_DATE}=true&${tokenAndFR}&${BET_LIST_PAGE_SEARCH_PARAMS.IS_REDIRECT}=true`);
  } else if (parsedInfo[0] === CMSINFO_REDIRECT_QUERY.BETS_BY_BOOSTED_ODD_ID) {
    window.location.replace(
      `/bets?${BET_LIST_PAGE_SEARCH_PARAMS.BOOSTED_ODD_ID}=${parsedInfo[1]}`
    + `&${BET_LIST_PAGE_SEARCH_PARAMS.SET_NO_DATE}=true`
    + `&${tokenAndFR}`
    + `&${BET_LIST_PAGE_SEARCH_PARAMS.IS_REDIRECT}=true`,
    );
  } else if (parsedInfo[0] === CMSINFO_REDIRECT_QUERY.EVENT_LIST) {
    const eventId = parsedInfo[1];
    const eventStartDate = parsedInfo.slice(2, -1).join(':');
    const providerId = parsedInfo[parsedInfo.length - 1];
    window.location.replace(`/eventsList?${EVENT_LIST_PAGE_SEARCH_PARAMS.EVENT_ID}=${eventId}`
     + `&${EVENT_LIST_PAGE_SEARCH_PARAMS.EVENT_START_DATE}=${eventStartDate}`
     + `&${EVENT_LIST_PAGE_SEARCH_PARAMS.PROVIDER_ID}=${providerId}&${tokenAndFR}&redirect=true`);
  } else if (parsedInfo[0] === CMSINFO_REDIRECT_QUERY.SUMS_REPORT) {
    window.location.replace(`/reports/sums?eid=${parsedInfo[1]}&${tokenAndFR}&redirect=true`);
  }
};
